import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "aside", "label", "link", "submenu", "collapseButton", "collapseIcon" ]

  static values = { collapsed: { type: Boolean, default: false } }

  connect() {
    this.applyCollapsedState()
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    requestAnimationFrame(() => window.dispatchEvent(new Event("resize")))
  }

  closeOnMobile() {
    if (window.matchMedia("(min-width: 64rem)").matches) return

    const toggle = this.element.querySelector(".drawer-toggle")
    if (toggle) toggle.checked = false
  }

  collapsedValueChanged() {
    this.applyCollapsedState()
  }

  applyCollapsedState() {
    const collapsed = this.collapsedValue

    this.asideTarget.classList.toggle("is-collapsed", collapsed)

    if (collapsed) {
      this.submenuTargets.forEach((submenu) => submenu.removeAttribute("open"))
    }

    if (this.hasCollapseIconTarget) {
      this.collapseIconTarget.classList.toggle("rotate-180", collapsed)
    }

    if (this.hasCollapseButtonTarget) {
      this.collapseButtonTarget.title = collapsed ? "Expandir menú" : "Contraer menú"
    }
  }
}
